import { Injectable } from "@angular/core";
import { Mutation } from "apollo-angular";
import gql from "graphql-tag";

export type WrappedResponse = {
  data: {
    sendAppLink: Response;
  };
};

type Response = {
  success: boolean;
  errors: string[];
};

type Variables = {
  phoneNumber: string;
  appStoreRedirectUrl: string;
};

@Injectable({
  providedIn: "root",
})
export class SendAppLinkGraphql extends Mutation<Response, Variables> {
  document = gql`
    mutation SendAppLink($phoneNumber: String!, $appStoreRedirectUrl: String!) {
      sendAppLink(input: { phoneNumber: $phoneNumber, appStoreRedirectUrl: $appStoreRedirectUrl }) {
        success
        errors
      }
    }
  `;
}
